module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHklEQVQ4jZ2S4W3CUAyEP6r+b0bIBs0GpBNAJyhMUJigMEFhA5gAmKDpBKUb0A3YgOrQWXp6efzhpCiKY5/vbA9YXLgTNTB5vKO2AhrgTQQPN5LEvnByjhnwpWLFSwQq+gE+nJhjBbwAm1sEO5N0lvpZUNf63SOY+OfSXTpLbpKcxuraEsE7cLJMYZrEA5I+cJMegdj3wNnfJ6uoM5UXq+gRnDO5VfYtHN29KxGs7W2XrKtyPBCq9CY/JO3+ycVjx5a2FZiFfK7DKJ9y7eeYzCNFm16iPOa+Y2hRrJiKrquzhb+woKsTtB55Dd8R2ybHFUN8BUZhQd10beFZ0P6Hce/GHHjOYlMp0DTFqOEoQR0lUd1/TaRYDPLbsQOw/wdAZUEvODse7QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/subDevice/son_icon_water_level.png
// module id = 2OP5
// module chunks = 4